<template>
    <div :id="identificator" />
</template>

<script>
const loadbeeLoaderUrl = 'https://cdn.loadbee.com/js/loadbee_integration.js';

export default {
    props: {
        productId: {
            type: String,
            required: true,
        },
        apikey: {
            type: String,
            required: true,
        },
        locale: {
            type: String,
            required: false,
        },
        debug: {
            type: String,
            required: false,
        },
    },
    data: () => ({
        identificator: 'loadbee-dataview-conainer',
    }),
    mounted() {
        if (!document.getElementById(this.identificator)) {
            // Script is not loaded yet, we initialize new load
            this.load(100, 10000, [loadbeeLoaderUrl], () => {
                this.loadbeeInit();
            });
        } else {
            // Script is already loaded just create new loadbee dataview
            this.loadbeeInit();
        }
    },
    methods: {
        loadbeeInit() {
            let element = document.getElementById(this.identificator);
            let dataContainer = document.createElement('div');
            dataContainer.setAttribute('class', 'loadbeeTabContent');
            dataContainer.setAttribute('data-loadbee-apikey', this.apikey);
            dataContainer.setAttribute('data-loadbee-gtin', this.productId);
            dataContainer.setAttribute('data-loadbee-locale', this.locale);
            dataContainer.setAttribute('data-loadbee-debug', 'false');
            element.appendChild(dataContainer);

            let script = document.createElement('script');
            script.src = loadbeeLoaderUrl;
            element.appendChild(script);
        },
    },
};
</script>